<template>
  <div class="baoxiuBox">
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item label="服务内容">
          <el-input v-model="ruleForm.taskContent" type="textarea" placeholder="请输入预约服务内容"></el-input>
        </el-form-item>
      </el-form>

    </el-card>
    <button style="width:100%" class="btn_bind" type="primary" @click="submitForm('ruleForm')">立 即 报 修</button>
  </div>
</template>

<script>
import { getTaskType, baoxiu } from "@/api";
export default {
  name:'yuyuefuwu',
  data() {
    return {
      ruleForm: {
        taskType:'预约服务'
      },
      rules: {
        taskType: [
          { required: true, message: "请选择报修类型", trigger: "change" },
        ],
      },
      taskOption: [],
      value: "",
    };
  },
  mounted() {
    this.getTaskType();
    this.ruleForm.openId = sessionStorage.getItem('thirdId')
    this.ruleForm.userCode = this.$route.query.code
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          baoxiu(this.ruleForm).then(res=>{
            this.$toast('报修成功')
            this.$router.go(-1)
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 获取类型
     */
    getTaskType() {
      getTaskType(sessionStorage.getItem("companyCode")).then((res) => {
        this.taskOption = res.data;
      });
    },

  },
};
</script>
<style  scoped>
.baoxiuBox {
  /* background: #fff; */
  padding: 3% 3%;
  min-height: 90%;
}
.baoxiuBox .el-select {
  width: 100%;
}

</style>




// WEBPACK FOOTER //
// src/view/ywbl/yuyue/yuyuefuwu.vue